import { render, staticRenderFns } from "./SettingsKpiRecipientsPage.vue?vue&type=template&id=2acafc07"
import script from "./SettingsKpiRecipientsPage.vue?vue&type=script&lang=ts"
export * from "./SettingsKpiRecipientsPage.vue?vue&type=script&lang=ts"
import style0 from "./SettingsKpiRecipientsPage.vue?vue&type=style&index=0&id=2acafc07&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports